import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function OAuthErrorPage() {
  const [errorMessage, setErrorMessage] = useState<string>('Loading...');

  useEffect(() => {
    fetch('/api/v1/oauth-error')
      .then(response => response.json())
      .then(data => setErrorMessage(data.errorMessage || 'An unknown error occurred'))
      .catch(() => setErrorMessage('An unknown error occurred'));
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Something went wrong</h1>
        <div className="error-message">
          {errorMessage}
        </div>
        <p style={{ marginTop: '1.5rem', fontSize: '1rem', color: '#ccc' }}>
          Please try installing again from the home page.
        </p>
        <Link to="/" style={{ display: 'inline-block', marginTop: '1rem', color: '#58a6ff', textDecoration: 'underline', fontSize: '1rem' }}>
          Back to Home
        </Link>
      </header>
    </div>
  );
}

export default OAuthErrorPage;
